import customAxios from "./axiosConfig";

const FinancialReportingService = {
    list: function (params) {
        var api_url = window.Urls['financial_report_list']();
        return customAxios.get(api_url, {params: params});
    },
    recalculate: function (params) {
        var api_url = window.Urls['financial_report_recalculate']();
        return customAxios.get(api_url, {params: params});
    },
    create: function(data) {
        var api_url = window.Urls['financial_report_list']();
        return customAxios.post(api_url, data);
    },
    update: function (pk, data) {
        var api_url = window.Urls['financial_report_detail'](pk);
        return customAxios.put(api_url, data);
    },
    getFinancialStatementsPDFBlob(params){
        const api_url = window.Urls['financial_report_download']()
        return customAxios.get(api_url, { params: params, responseType: 'blob' }).then((response) => {
            return response
        })
    },
}

export default FinancialReportingService;